/**
 * Formats seconds remaining as `MM:SS` under an hour and `HH:MM:SS` at or above it [decision 0064].
 *
 * Takes a DURATION, never a timestamp, and that is the whole point: the api returns seconds remaining
 * precisely so a kiosk with a skewed device clock cannot render a wrong countdown. A formatter that took a
 * deadline would quietly reintroduce the dependency the contract was shaped to remove.
 */
export function formatRemaining(totalSeconds: number): string {
  const safe = Math.max(0, Math.floor(totalSeconds));

  const hours = Math.floor(safe / 3600);
  const minutes = Math.floor((safe % 3600) / 60);
  const seconds = safe % 60;

  const pad = (value: number): string => String(value).padStart(2, '0');

  return hours > 0
    ? `${pad(hours)}:${pad(minutes)}:${pad(seconds)}`
    : `${pad(minutes)}:${pad(seconds)}`;
}
